import styled from "styled-components";
import { rem } from "polished";

export const PageRow = styled.div`
  box-sizing: border-box;
  padding: 0 ${rem(16)};
`;
